/* ══ BDT ENGINE ══ */
(function(){
var R=matchMedia('(prefers-reduced-motion: reduce)').matches;
var $=function(s,r){return (r||document).querySelector(s)},
    $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};

/* ── no cold-open gate: the game feel lives in the HUD, not a loader ── */

/* ── page wipe ── */
var w=document.createElement('div');w.className='wipe';document.body.appendChild(w);
/* re-entrant-safe: only the most recent navigation may apply, and the
   curtain always returns to a clean class state even on rapid clicks */
var wT1,wT2,wPend=null;
function transition(cb){
  if(R){cb();reveal();return}
  wPend=cb;
  if(wT1){
    /* already mid-wipe: swap in the newest target, don't stack timers */
    return;
  }
  w.className='wipe i';
  wT1=setTimeout(function(){
    wT1=null;
    var run=wPend;wPend=null;
    if(run)run();
    w.className='wipe o';
    clearTimeout(wT2);
    wT2=setTimeout(function(){wT2=null;w.className='wipe'},600);
    reveal();
  },540);
}

/* ── progress + level HUD ── */
var pr=document.createElement('div');pr.className='prog';pr.innerHTML='<i></i><b></b>';document.body.appendChild(pr);
var pbar=pr.firstChild,ppuck=pr.lastChild;
var hud=document.createElement('div');hud.className='hud';document.body.appendChild(hud);
var levels=[],cur=-1;

/* ── level-up stamp ── */
var stamp=document.createElement('div');stamp.className='lvup';
stamp.innerHTML='<span class="n"></span><span class="t"></span><i></i>';
document.body.appendChild(stamp);
var stT;
function levelUp(i,first){
  if(R)return;
  $('.n',stamp).textContent='Level '+String(i).padStart(2,'0');
  $('.t',stamp).textContent=levels[i]&&levels[i].dataset.lv||'';
  $('i',stamp).textContent=first?'Entered':'Cleared '+String(i-1).padStart(2,'0');
  stamp.classList.remove('go');void stamp.offsetWidth;stamp.classList.add('go');
  clearTimeout(stT);stT=setTimeout(function(){stamp.classList.remove('go')},1500);
}

/* ── keyboard controls ── */
function off(){var h=document.getElementById('hdrwrap');return (h?h.offsetHeight:56)+6}
window.BDTOFF=off;
var legend=document.createElement('div');legend.className='keys';
legend.innerHTML='<span><b>\u2191\u2193</b> levels</span><span><b>S</b> shop</span><span><b>H</b> home</span>';
document.body.appendChild(legend);
var lgT=setTimeout(function(){legend.classList.add('dim')},9000);
legend.classList.add('off');

/* ── hero sizing: subtract the sticky chrome above it ── */
function chrome(){
  var h=$('.page.on .hero');if(!h)return;
  var top=h.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop||0);
  document.documentElement.style.setProperty('--chrome',Math.round(top)+'px');
}
function hop(d){
  if(!levels.length)return;
  var n=Math.max(0,Math.min(levels.length-1,(cur<0?0:cur)+d));
  window.scrollTo({top:levels[n].offsetTop-off(),behavior:R?'auto':'smooth'});
}
document.addEventListener('keydown',function(e){
  if(e.defaultPrevented||e.metaKey||e.ctrlKey||e.altKey)return;
  var tg=e.target;if(tg&&(/^(input|textarea|select|button|a)$/i.test(tg.tagName)||tg.isContentEditable||document.querySelector('.qvm.on,.cdr.on,.srch.open')))return;
  var k=(e.key||'').toLowerCase(),used=true;
  if(k==='arrowdown'||k===']')hop(1);
  else if(k==='arrowup'||k==='[')hop(-1);
  else if(k==='s'){var b=document.querySelector('.hdr [data-p="shop"]');if(b)b.click()}
  else if(k==='h'){var c=document.querySelector('.hdr [data-p="home"]');if(c)c.click()}
  else used=false;
  if(used){e.preventDefault();clearTimeout(lgT);legend.classList.remove('dim');lgT=setTimeout(function(){legend.classList.add('dim')},5000)}
});

function buildHud(){
  var pg=$('.page.on');if(!pg){hud.innerHTML='';return}
  levels=$$('[data-lv]',pg);cur=-1;
  if(!levels.length){hud.innerHTML='';return}
  hud.innerHTML='<span class="lvl">Lv <b id="hudn">00</b>/'+String(levels.length-1).padStart(2,'0')+'</span>';
  levels.forEach(function(s,i){
    var b=document.createElement('button');b.type='button';
    b.setAttribute('aria-label','Go to level '+String(i).padStart(2,'0')+', '+(s.dataset.lv||''));
    b.innerHTML='<span>'+(s.dataset.lv||'')+'</span><em>'+String(i).padStart(2,'0')+'</em><i></i>';
    b.addEventListener('click',function(){
      window.scrollTo({top:s.offsetTop-off(),behavior:R?'auto':'smooth'});
    });
    hud.appendChild(b);
  });
}

function onScroll(){
  var d=document.documentElement,max=d.scrollHeight-d.clientHeight,q=(max>0?d.scrollTop/max*100:0);
  pbar.style.width=q+'%';ppuck.style.left=q+'%';
  if(!R){
    $$('.page.on .bleed .m').forEach(function(el){
      var r=el.parentNode.getBoundingClientRect(),vh=innerHeight;
      if(r.bottom<-160||r.top>vh+160)return;
      el.style.transform='translate3d(0,'+(((r.top+r.height/2-vh/2)/vh)*-6).toFixed(2)+'%,0)';
    });
  }
  sweep();
  if(levels.length){
    var mid=innerHeight*.45,act=0;
    for(var i=0;i<levels.length;i++){
      if(levels[i].getBoundingClientRect().top<=mid)act=i;else break;
    }
    var k=hud.querySelectorAll('button');
    for(var j=0;j<k.length;j++)k[j].classList.toggle('on',j===act);
    if(act!==cur){
      var first=cur<0;cur=act;
      var hn=document.getElementById('hudn');if(hn)hn.textContent=String(act).padStart(2,'0');
      legend.classList.toggle('off',act<1);
      if(!first||act>0)levelUp(act,first);
    }
  }
}

/* ── masked heading lines ── */
function split(el){
  if(el._s)return;el._s=1;
  var out=[];
  [].slice.call(el.childNodes).forEach(function(nd){
    if(nd.nodeType===3){
      nd.textContent.split(/(\s+)/).forEach(function(t){
        if(!t.trim()){if(t)out.push({sp:1});return}
        var s=document.createElement('span');s.className='wd';s.textContent=t;out.push({el:s});
      });
    }else if(nd.nodeName==='BR'){out.push({br:1});}
    else{var c=nd.cloneNode(true);if(c.classList)c.classList.add('wd');out.push({el:c});}
  });
  el.innerHTML='';
  out.forEach(function(u){
    if(u.sp)el.appendChild(document.createTextNode(' '));
    else if(u.br)el.appendChild(document.createElement('br'));
    else el.appendChild(u.el);
  });
  var words=$$('.wd',el);if(!words.length)return;
  var lines=[],cur=[],top=null;
  words.forEach(function(x){
    var t=x.offsetTop;
    if(top===null||Math.abs(t-top)<6){cur.push(x);if(top===null)top=t}
    else{lines.push(cur);cur=[x];top=t}
  });
  if(cur.length)lines.push(cur);
  var f=document.createDocumentFragment();
  lines.forEach(function(ws,i){
    if(i)f.appendChild(document.createTextNode(' '));
    var l=document.createElement('span');l.className='ln';
    var inn=document.createElement('span');inn.className='ln-i';
    inn.style.transitionDelay=(i*85)+'ms';
    ws.forEach(function(x,k){if(k)inn.appendChild(document.createTextNode(' '));inn.appendChild(x)});
    l.appendChild(inn);f.appendChild(l);
  });
  el.innerHTML='';el.appendChild(f);
}

/* ── counters ── */
function count(el){
  if(el._d)return;el._d=1;
  var m=el.textContent.trim().match(/^([^\d]*)([\d,\.]+)(.*)$/);
  if(!m)return;
  var pre=m[1],post=m[3],tgt=parseFloat(m[2].replace(/,/g,'')),dec=(m[2].split('.')[1]||'').length;
  if(!isFinite(tgt))return;
  var t0=null,D=1500;
  function s(ts){
    if(!t0)t0=ts;
    var q=Math.min((ts-t0)/D,1),v=(tgt*(1-Math.pow(1-q,3))).toFixed(dec);
    el.textContent=pre+Number(v).toLocaleString('en-US',{minimumFractionDigits:dec,maximumFractionDigits:dec})+post;
    if(q<1)requestAnimationFrame(s);
  }
  requestAnimationFrame(s);
}

/* ── svg path lengths ── */
function prepVec(svg){
  if(svg._v)return;svg._v=1;
  $$('path,line,polyline,circle,rect',svg).forEach(function(p){
    if(p.classList.contains('nd'))return;
    var L=600;try{if(p.getTotalLength)L=p.getTotalLength()}catch(e){}
    p.style.setProperty('--L',Math.ceil(L||600));
  });
}

/* ── reveal engine ──
   Content ships VISIBLE. The hidden states behind html.anim are only armed once
   an IntersectionObserver callback has actually fired, proving IO works here.
   A scroll-driven pass runs alongside IO, and a hard timeout un-arms everything
   if IO never delivers, so the page can never end up blank. */
var io=null,armed=false,watched=[];

function show(t){
  if(t.classList.contains('ln'))t.classList.add('on');
  else t.classList.add('in');
  if(t.classList.contains('stat')){var v=$('.v',t);if(v)count(v)}
}
function disarm(){
  armed=false;
  document.documentElement.classList.remove('anim');
  watched.forEach(show);
}
/* scroll-driven fallback, always active, independent of IO */
function sweep(){
  if(!watched.length)return;
  var vh=innerHeight,left=0;
  for(var i=0;i<watched.length;i++){
    var e=watched[i];
    if(e.classList.contains('in')||e.classList.contains('on'))continue;
    var r=e.getBoundingClientRect();
    if(r.top<vh*.95&&r.bottom>0)show(e);else left++;
  }
  return left;
}

function reveal(){
  buildHud();chrome();
  var pg=$('.page.on');if(!pg)return;
  $$('.d1,.d2',pg).forEach(split);
  $$('.pc .im, .sc .im, .cat, .split>.m',pg).forEach(function(e){e.classList.add('iv')});
  $$('.vec',pg).forEach(prepVec);

  watched=$$('.rv,.ln,.iv,.vec,.stat,.lvhd',pg);

  if(R||!('IntersectionObserver' in window)){disarm();onScroll();return;}

  /* backstop armed FIRST: if IO has not proven itself in 1.6s, show everything */
  clearTimeout(reveal._sw);
  reveal._sw=setTimeout(function(){if(!io||!io._fired)disarm();},1600);

  $$('.rv',pg).forEach(function(e,i){e.style.transitionDelay=Math.min(i%5*65,300)+'ms'});

  if(io)io.disconnect();
  io=new IntersectionObserver(function(es){
    if(!io._fired){
      io._fired=true;
      clearTimeout(reveal._sw);
      /* IO is real, only now is it safe to hide anything */
      if(!armed){armed=true;document.documentElement.classList.add('anim');}
    }
    es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target)}});
  },{threshold:0,rootMargin:'0px 0px -5% 0px'});
  io._fired=false;
  watched.forEach(function(e){io.observe(e)});
  onScroll();
  /* deterministic settle: sweep for ~1s so anything already in view reveals
     even if IO is slow, throttled, or never re-fires after a programmatic scroll */
  clearInterval(reveal._st);
  var n=0;
  reveal._st=setInterval(function(){
    if(io&&io._fired){clearInterval(reveal._st);return;}
    if(++n>20||sweep()===0)clearInterval(reveal._st);
  },50);
}

/* ── drag rails ── */
function rails(){
  $$('.rail').forEach(function(rl){
    if(rl._w)return;rl._w=1;
    var dn=false,sx=0,sl=0,mv=0;
    rl.addEventListener('pointerdown',function(e){dn=true;mv=0;sx=e.clientX;sl=rl.scrollLeft;try{rl.setPointerCapture(e.pointerId)}catch(x){}});
    rl.addEventListener('pointermove',function(e){
      if(!dn)return;var d=e.clientX-sx;mv=Math.max(mv,Math.abs(d));
      if(mv>6)rl.classList.add('drag');rl.scrollLeft=sl-d;
    });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
      rl.addEventListener(ev,function(){dn=false;setTimeout(function(){rl.classList.remove('drag')},40)});
    });
    var bar=rl.parentNode.querySelector('.railbar>span');
    if(bar){
      var up=function(){
        var max=rl.scrollWidth-rl.clientWidth,fr=rl.clientWidth/rl.scrollWidth;
        bar.style.width=(fr*100)+'%';
        bar.style.transform='translateX('+(max>0?rl.scrollLeft/max*((1/fr-1)*100):0)+'%)';
      };
      rl.addEventListener('scroll',up,{passive:true});addEventListener('resize',up);up();
    }
  });
}

/* ── hero video (source injected at runtime so the static bundle stays light) ── */
function vids(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||navigator.connection?.saveData)return;
  $$('video[data-src]').forEach(function(v){
    if(v._l)return;v._l=1;
    var s=document.createElement('source');s.src=v.dataset.src;s.type='video/mp4';
    v.appendChild(s);v.load();
    var ok=function(){v.classList.add('rdy')};
    v.addEventListener('loadeddata',ok);v.addEventListener('playing',ok);
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  });
}

window.BDT={transition:transition,rebind:function(){reveal();rails()}};
var scrollPending=false;addEventListener('scroll',function(){if(scrollPending)return;scrollPending=true;requestAnimationFrame(function(){scrollPending=false;onScroll()})},{passive:true});
addEventListener('resize',function(){chrome();onScroll()});
function go(){reveal();rails();setTimeout(vids,260);addEventListener('load',chrome)}
function ready(){Promise.race([document.fonts?document.fonts.ready:Promise.resolve(),new Promise(function(resolve){setTimeout(resolve,1400)})]).then(go)}if(document.readyState!=='loading')ready();else document.addEventListener('DOMContentLoaded',ready);
})();
